import React from 'react';
import { PlayCircleIcon } from 'lucide-react';
export function VideoSection() {
  return <section className="w-full bg-gradient-to-b from-[#111116] to-[#141418] py-8 md:py-16 px-4" data-id="element-279">
      <div className="max-w-3xl mx-auto" data-id="element-280">
        <div className="bg-[#1a1a22] p-6 md:p-12 rounded-2xl border-l-4 border-[#e53935] shadow-lg" data-id="element-281">
          <div className="flex justify-center mb-5" data-id="element-282">
            <div className="bg-gradient-to-br from-[#e53935]/20 to-[#ff7043]/10 p-4 rounded-2xl" data-id="element-283">
              <PlayCircleIcon className="w-10 h-10 md:w-14 md:h-14 text-[#ef5350]" aria-hidden="true" data-id="element-284" />
            </div>
          </div>
          <p className="text-xs md:text-sm text-[#ef5350] font-black tracking-widest uppercase text-center mb-2" data-id="element-285">
            El núcleo de la formación
          </p>
          <h2 className="text-2xl md:text-4xl font-black text-white mb-4 text-center leading-tight" data-id="element-286">
            Aprendé viendo: Clases en{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#ef5350] to-[#ff7043]" data-id="element-287">
              video
            </span>{' '}
            paso a paso
          </h2>
          <div className="w-12 h-0.5 bg-gradient-to-r from-[#e53935] to-[#ff7043] mx-auto mb-4" data-id="element-288"></div>
          <p className="text-sm md:text-lg text-gray-300 leading-relaxed text-center mb-4" data-id="element-289">
            Vas a ver cada técnica aplicada en tiempo real. Nada de teoría
            aburrida:{' '}
            <span className="text-white font-bold" data-id="element-290">
              pura práctica profesional
            </span>{' '}
            para que entiendas exactamente cómo usar la máquina, la tijera y la
            navaja.
          </p>
          <p className="text-sm md:text-base text-gray-200 font-black text-center mb-6 md:mb-8" data-id="element-291">
            Y para que nunca te olvides de nada, tenés el manual completo del
            método como material de apoyo permanente.
          </p>

          {/* Video de muestra */}
          <div className="flex justify-center mb-8 md:mb-10" data-id="element-292">
            <div className="relative w-full max-w-[260px] md:max-w-[300px] aspect-[9/17] rounded-2xl overflow-hidden shadow-2xl border-2 border-white/10 bg-black" data-id="element-293">
              <video src="https://cdn.magicpatterns.com/uploads/qdzBtYXgH9hikWXiEjmQtq/WhatsApp%20Video%202026-02-24%20at%2001.30.47.mp4" autoPlay loop muted playsInline className="w-full h-full object-cover scale-[1.15] origin-center" data-id="element-294" />
            </div>
          </div>

          <div className="bg-[#111116] border border-[#e53935]/30 rounded-xl p-4 md:p-6" data-id="element-295">
            <p className="text-gray-300 text-sm md:text-base text-center leading-relaxed" data-id="element-296">
              🎥{' '}
              <span className="font-bold text-white" data-id="element-297">
                Clases en video para aprender la técnica
              </span>{' '}
              + 📘{' '}
              <span className="font-bold text-white" data-id="element-298">
                Manual completo para repasar y consultar
              </span>{' '}
              = Formación profesional
            </p>
          </div>
        </div>
      </div>
    </section>;
}